export function problemUrl(id: string): string {
  const encoded = encodeURIComponent(id);
  return `/resource_mapping/problems/${encoded}`;
}
